import React, { useEffect, useState } from 'react';
import Box from 'core/ui/Box';
import { useSelector } from 'react-redux';
import { sessionSelectors } from 'modules/session';
import useActions from 'modules/map/useActions';
import Modules from 'modules';
import useSelectors from 'modules/map/useSelectors';
import { ButtonPrimary } from 'core/ui/Button';
import { Add, Search } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import LoaderSm from 'core/ui/LoaderSm';
import { showAPIError } from 'core/utils/showAPIError';
import DatePickerRounded from 'core/ui/DatePickers/DatePickerRounded';
import { formatDateToApi } from 'core/utils/formatters';
import { salesUsersChannelsModule } from 'modules/salesUsersChannels';
import ModalForm from './Form/Modal';
import ResultSales from './ResultSales';
import ModalSetUserAsSale from './Modal';

const ListSalesUsersChannels = () => {
  const { t } = useTranslation();
  const currentUser = useSelector((state) => sessionSelectors.getUser(state));
  const isAdmin = useSelector((state) => sessionSelectors.getIsAdmin(state));
  const { request } = useActions();
  const [modalForm, setModalForm] = useState({ open: false });
  const [modalAddUser, setModalAddUser] = useState({ open: false });
  const [results, setResults] = useState([]);

  const loading = useSelectors(salesUsersChannelsModule, 'loading');

  const dateNow = new Date();

  const [filters, setFilters] = useState({
    startAt: `${dateNow.getMonth() + 1}/1/${dateNow.getFullYear()}`,
    endAt: `${dateNow.getMonth() + 1}/${dateNow.getDate()}/${dateNow.getFullYear()}`,
    workoutId: '',
  });

  const getSalesReport = () => {
    const startAt = filters.startAt ? formatDateToApi(filters.startAt) : null;
    const endAt = filters.endAt ? formatDateToApi(filters.endAt) : null;
    request({
      action: Modules.salesUsersChannels.actions.getSalesReport,
      data: {
        ...filters,
        startAt,
        endAt,
      },
      options: {
        onSuccess: (resp) => {
          setResults(resp);
        },
      },
    });
  };

  const createSalesUser = (user) => {
    request({
      action: Modules.salesUsersChannels.actions.setUserAsSales,
      data: {
        userId: user?.id,
      },
      options: {
        onSuccess: () => {
          setModalAddUser({});
          getSalesReport();
        },
        onError: showAPIError,
      },
    });
  };

  useEffect(() => {
    if (isAdmin) {
      getSalesReport();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  return (
    <Box>
      <ModalSetUserAsSale
        modalAddUser={modalAddUser}
        setModalAddUser={setModalAddUser}
        createSalesUser={createSalesUser}
      />

      <Box className="tw-wrap tw-m-4 tw-flex tw-flex-row tw-items-end tw-justify-center tw-gap-2 tw-bg-white tw-p-4">
        <Box>
          <DatePickerRounded
            label={t('channel.reports.filter.start').toUpperCase()}
            onChange={(v) => setFilters((prev) => ({ ...prev, startAt: v }))}
            value={filters.startAt}
            disablePast={false}
            autoOk
            bordered
          />
        </Box>
        <Box>
          <DatePickerRounded
            label={t('channel.reports.filter.end').toUpperCase()}
            onChange={(v) => setFilters((prev) => ({ ...prev, endAt: v }))}
            value={filters.endAt}
            disablePast={false}
            autoOk
            bordered
          />
        </Box>
        <Box>
          <ButtonPrimary disabled={loading} onClick={() => getSalesReport()}>
            <Search style={{ color: 'white' }} fontSize="small" />
            {t('button.search')}&nbsp;
          </ButtonPrimary>
        </Box>
        <Box>
          <ButtonPrimary onClick={() => setModalAddUser({ open: true })}>
            <Add />
            {t('button.createSales')}&nbsp;
          </ButtonPrimary>
        </Box>
      </Box>

      <ResultSales results={results?.salesUsers || []} setModalForm={setModalForm} />
      {loading && (
        <Box display="flex" alignItems="center" m={3} justifyContent="center">
          <LoaderSm loading />
        </Box>
      )}
      <ModalForm
        userId={modalForm?.userId}
        salesUserChannelId={modalForm?.salesUserChannelId}
        open={modalForm?.open}
        close={() => setModalForm({ open: false })}
        callbackSave={() => {
          setModalForm({ open: false });
          getSalesReport();
        }}
      />
    </Box>
  );
};

export default ListSalesUsersChannels;
